module.exports = __webpack_public_path__ + "img/MoMobil4.02682268.png";